import React from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import { useRouter } from "next/navigation";
import Image from "next/image";

function MainSection(props: {
  title: string;
  subtitle: string;
  image: string;
  mobileImage: string;
  buttonPath: string;
  buttonText: string;
  buttonColor: "primary" | "secondary";
}) {
  const router = useRouter();
  const handleClick = () => {
    if (props.buttonPath === "/welcome") {
      if (window !== undefined) {
        sessionStorage.setItem("createdExamId", "");
      }
    }
    router.push(props.buttonPath);
  };
  return (
    <Box sx={{ py: 0, padding: { xs: "30px 0 0", sm: "50px 0 0" } }}>
      <Container maxWidth={false} className={"containerWidth"}>
        <Grid container={true} alignItems="center" spacing={6}>
          <Grid container={true} item={true} direction="column" xs={12} md={6}>
            <Box textAlign={{ xs: "center", md: "left" }}>
              <Box sx={{ mb: "2rem" }}>
                {props.title && (
                  <Typography
                    variant={"h4"}
                    gutterBottom={!!props.subtitle}
                    fontWeight={900}
                    sx={{ fontSize: { xs: "28px", sm: "40px" } }}
                  >
                    {props.title}
                  </Typography>
                )}

                {props.subtitle && (
                  <Typography variant="subtitle1">{props.subtitle}</Typography>
                )}
              </Box>
              <Button
                variant="contained"
                size="large"
                color={props.buttonColor}
                onClick={handleClick}
              >
                {props.buttonText}
              </Button>
            </Box>
          </Grid>
          <Grid
            item={true}
              className={'desktopImage'}
            md={true}
            sx={{
              display: "flex",
              justifyContent: { lg: "end", xs: "center" },
            }}
          >
            <Image
              src={props.image}
              width={100}
              height={100}
              alt="illustration"
              priority
              style={{
                maxWidth: 570,
                display: "block",
                height: "auto",
                width: "100%",
                float: "right",
              }}
            />
            <img
              className={'mobileImage'}
              src={props.mobileImage}
              alt="illustration"
              style={{
                maxWidth: 400,
                display: "block",
                height: "auto",
                width: "100%",
                float: "right",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default MainSection;
